import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { ToastProvider } from './components/common/Toast';
import './styles/globals.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

// ToastProvider is outermost so its error sink is registered before anything
// below can fail: a crash caught by the ErrorBoundary reports through the sink
// and surfaces as a toast as well as the fallback card. The ErrorBoundary wraps
// the whole app so a single render crash never blanks the screen.
createRoot(root).render(
  <StrictMode>
    <ToastProvider>
      <ErrorBoundary>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ErrorBoundary>
    </ToastProvider>
  </StrictMode>,
);
